module.exports = __webpack_public_path__ + "static/media/search-black-50.3cdf4a95.svg";